module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Hansel&GretelWitchHunters.ad6bf4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Hansel&GretelWitchHunters.jpg
// module id = 8A94
// module chunks = 0